import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/topic/section"

const topicSection = {
  sectionSortListPage(pageSize, limit, keyWord, subjectId, versionId, bookId, gradeId) {
    return axios.get(pre + `/sectionSortListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          subjectId: subjectId,
          versionId: versionId,
          bookId: bookId,
          gradeId: gradeId,
        }
    });
  },
  sectionSortAllList(subjectId, classId, versionId, bookId) {
    return axios.get(pre + `/sectionSortAllList`, {
      params:
        {
          subjectId: subjectId,
          classId: classId,
          versionId: versionId,
          bookId: bookId,
        }
    });
  },
  sectionChildSortList(sectionId) {
    return axios.get(pre + `/sectionChildSortList`, {
      params:
        {
          sectionId: sectionId
        }
    });
  },
  sectionSortInfo(id) {
    return axios.get(pre + `/sectionSortInfo`, {params: {id: id}});
  },
  saveSectionSort(params) {
    return axios.post(pre + `/saveSectionSort`, qs.stringify(params));
  },
  sectionSortDelete(id) {
    return axios.delete(pre + `/sectionSortDelete`, {params: {id: id}});
  },
  importSectionSort(params) {
    return axios.post(pre + `/importSectionSort`, params);
  },
}
export default topicSection;



// WEBPACK FOOTER //
// ./src/api/topic/topicSection.js